import styled from 'styled-components';
import React from 'react';
import { UIText } from '../typography';
import { theme } from '../../theme';
import {
  CheckCircleFilledIcon,
  CrossCircleFilledIcon,
  MinusCircleFilledIcon,
} from '../../assets';

export type ReserveStatusMappingType = {
  [key: string]: {
    text: string;
    icon: string;
  };
};

export type ReserveBarProps = {
  reserveStatus: string;
  reserveStatusMapping?: ReserveStatusMappingType[];
  className?: string;
};

const ReserveContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

const ReserveText = styled(UIText).attrs({ size: 'xs' })`
  color: ${theme.colors.neutrals.solidGrays[3]};
`;

const CheckIcon = styled(CheckCircleFilledIcon)`
  fill: ${theme.colors.system.systemGreen};
`;

const MinusIcon = styled(MinusCircleFilledIcon)`
  fill: ${theme.colors.system.systemOrange};
`;

const CrossIcon = styled(CrossCircleFilledIcon)`
  fill: ${theme.colors.primary.graysRed};
`;

const getReserveIcons = (iconName: string) => {
  switch (iconName) {
    case 'CheckIcon':
      return <CheckIcon width={21} />;
    case 'CrossIcon':
      return <CrossIcon width={21} />;
    case 'MinusIcon':
      return <MinusIcon width={21} />;
    default:
      return null;
  }
};

export const ReserveBar: React.FC<ReserveBarProps> = ({
  reserveStatusMapping,
  reserveStatus,
  className,
}) => {
  const reserveStatusItem =
    reserveStatusMapping &&
    reserveStatus &&
    reserveStatusMapping.find((item) => item[reserveStatus]);

  if (!reserveStatusItem) {
    return null;
  }

  const { text, icon } = reserveStatusItem[reserveStatus];
  const IconComponent = getReserveIcons(icon);

  return (
    <ReserveContainer className={className}>
      {IconComponent && IconComponent}
      <ReserveText>{text}</ReserveText>
    </ReserveContainer>
  );
};
